export default __webpack_public_path__ + "static/media/traduora-preview.2bbc167d.png";